import { Link } from 'react-router-dom';
import { cases } from '@/mocks/cases';

export default function FeaturedWork() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100" aria-labelledby="work-title">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium tracking-wide uppercase mb-4">
            精选案例
          </span>
          <h2 id="work-title" className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-4">
            用结果说话的实战案例
          </h2>
          <p className="text-foreground-600 leading-relaxed">
            每一个项目背后，都是策略、创意与执行的精密配合
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {cases.map((c) => (
            <article
              key={c.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300/60 hover:shadow-lg transition-all duration-300"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={c.imageUrl}
                  alt={c.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-medium">
                    {c.category}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <p className="text-xs text-foreground-500 mb-2">{c.client}</p>
                <h3 className="text-base font-semibold font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {c.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
                  {c.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-accent-600">
                    {c.metric}
                  </span>
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:gap-2 transition-all">
                    查看详情
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line" />
                    </span>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}